import { render, staticRenderFns } from "./category.vue?vue&type=template&id=c83bae68&vue3"
import script from "./category.vue?vue&type=script&lang=js&vue3"
export * from "./category.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports